import axios from '@/util/requestUtil'
class ExchangeRate {
  // 换汇最新记录
  getExchangeRecords (params) {
    return axios.get(`/fund/currency-exchange/application/records`, params)
  }
  getExchangeRate (params) {
    return axios.get(`/fund/currency-exchange/rate`, params)
  }
  commitExchange (params) {
    return axios.post(`/fund/currency-exchange/application`, params)
  }
}

export default new ExchangeRate()
